import { SvgIcon, SvgIconProps } from "@mui/material";
import { lazy, Suspense } from "react";

interface Props extends SvgIconProps {
  icon: string;
}

const iconModules = import.meta.glob("../../../../theme/icons/*.tsx", {
  eager: false,
});

const iconCache = new Map<
  string,
  React.LazyExoticComponent<React.ComponentType<SvgIconProps>>
>();

function getOrCreateLazyIcon(
  icon: string
): React.LazyExoticComponent<React.ComponentType<SvgIconProps>> {
  const cached = iconCache.get(icon);
  if (cached) {
    return cached;
  }

  const modulePath = `../../../../theme/icons/${icon}.tsx`;
  const importer = iconModules[modulePath];

  if (!importer) {
    throw new Error(`Icon '${icon}' not found at ${modulePath}`);
  }

  const lazyIcon = lazy(async () => {
    const iconModule: any = await importer();
    return iconModule;
  });

  iconCache.set(icon, lazyIcon);
  return lazyIcon;
}

export default function IconLoader({ icon, ...props }: Props) {
  const DynamicIcon = getOrCreateLazyIcon(icon);

  return (
    <Suspense fallback={<SvgIcon sx={props?.sx} />}>
      <DynamicIcon {...props} />
    </Suspense>
  );
}
